// @ts-nocheck
import React, { useEffect,Component } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import logo from '../../TIP_tate.svg';
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link } from 'react-router-dom';
import {useIntl  , FormattedMessage } from 'react-intl';
import ReactGA from "react-ga4";
import ga from './googleAnalytics/ga-init';
import { Helmet } from 'react-helmet-async';
//import {RecaptchaEnterpriseServiceClient} from '@google-cloud/recaptcha-enterprise';

/**
  * 評価を作成して UI アクションのリスクを分析する。
  *
  * projectID: Google Cloud プロジェクト ID
  * recaptchaSiteKey: サイト / アプリに関連付けられた reCAPTCHA キー
  * token: クライアントから取得した生成トークン。
  * recaptchaAction: トークンに対応するアクション名。
  */
async function createAssessment({
  // TODO: サンプルを実行する前に、トークンと reCAPTCHA アクション変数を置き換えます。
  projectID = "ownedmedia-1720468773998",
  recaptchaKey = process.env.REACT_APP_GC_KEY,
  token = "action-token",
  recaptchaAction = "action-name",
}) {
  // reCAPTCHA クライアントを作成する。
  // TODO: クライアント生成コードをキャッシュに保存するか（推奨）、メソッドを終了する前に client.close() を呼び出す。
  const client = new RecaptchaEnterpriseServiceClient();
  const projectPath = client.projectPath(projectID);

}

// Google Analytics 測定 ID を入力して設定
ReactGA.initialize(process.env.REACT_APP_GA_KEY);
// ページビューイベントを処理
ReactGA.send("pageview");
ga.trackPageView('search','/search');

const styles = (theme: { spacing: { unit: number; }; shape: { borderRadius: any; }; breakpoints: { up: (arg0: string) => any; }; transitions: { create: (arg0: string) => any; }; }) => ({
  root: {
  },
  textField: {
      marginLeft: theme.spacing.unit,
      marginRight: theme.spacing.unit,
      width: 200,
  },
  search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover': {
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing.unit,
          width: 'auto',
      },
  },
  searchIcon: {
      width: theme.spacing.unit * 9,
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
  },
  inputRoot: {
      color: 'inherit',
      width: '100%',
  },
  inputInput: {
      paddingTop: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 10,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
          width: 120,
          '&:focus': {
              width: 200,
          },
      },
  },
});


export default function Hero() {
  const intl = useIntl();
  const [category, setCategory] = React.useState(0);
  const [keyword, setKwyword] = React.useState('');
  const [postsSeo,setPostsSeo] = React.useState<Post[]>([]);

  const handleChange = (event:SelectChangeEvent) => {
    setCategory(event.target.value);
    
  }
  const handleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKwyword(event.target.value);
    
  }
      useEffect(() => {
      (async function () {
        var res =[];
        const data = await resSeoData();
        setPostsSeo(data);
      })();
     }, []);

    const resSeoData = async (): Promise<Post[]> => {
    const url = process.env.REACT_APP_SEO_API_URL;
    try{
      let bodyData;
      bodyData= {
      category: "24",
      keyword: "home"
      }

   const headers = new Headers({
            "Access-Control-Allow-Origin": process.env.REACT_APP_HOME_URL,
            'Access-Control-Allow-Credentials': 'true'
        });
  return fetch(url , {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(bodyData)
    })
    .then((response) => {
      if (!response.ok ){
        throw new Error('status is not 200');
      }
      return response.json();
    })
    .then(jsondata => {
      return jsondata;
    })
    .catch(error => {
    });
    }catch{
    }
};

   // TextfieldとButtonIconを合体させたコンポーネントの作成
 const AddButton = () => {
  const addButtonClick = () => {
    if(keyword !==""){
    // document.getElementById("demo-form").submit();
        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
    const aaa = document.getElementById("sc");
    aaa?.click();

  }};
  return (
    <IconButton onClick={() => addButtonClick()}>
      <SearchIcon />
    </IconButton>
  );
};
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        //width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage:
          'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
        ...theme.applyStyles('dark', {
          backgroundImage:
            'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
        }),
      })}
    >
      <Container 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 },
        }}
      ><Helmet>
                {(() => {
                  const tags = [];
                  for (let i in postsSeo) {
                    tags.push(<meta name="keywords" content={postsSeo[i].keyword} />)
                  }
                  return tags;
                })()}
                                {(() => {
                  const tags = [];
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "Column"} />)
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "news"} />)
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "notification"} />)
                    tags.push(<link rel="canonical" href={process.env.REACT_APP_HOME_URL + "relatedLinks"} />)
                  return tags;
                })()}
      </Helmet>
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              fontSize: 'clamp(3rem, 10vw, 3.5rem)',
            }}
          >
            <img src={logo} className="App-logo" alt="logo" width={"500px"} />
          </Typography>
          <Typography
            sx={{
              display: { xs: 'none', md: 'flex' },
              gap: 0.5,
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >

          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: 'auto' } }}
          >
            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 2 ,fontsize: "10px",}}> 
 <FormControl sx={{ m: 1, minWidth: "100",marginRight:2,margin:"0 0 0 0", md: 'flex',height:60}}>
        <InputLabel id="demo-simple-select-autowidth-label" sx={{ marginTop:-1, md: 'flex'}}></InputLabel>
        <Select
          labelId="demo-simple-select-autowidth-label"
          id="demo-simple-select-autowidth"
          defaultValue={0}
          onChange={handleChange}
          sx={{ maxWidth:"120px"}}
          w
        >
          <MenuItem value={0}><FormattedMessage id = "langID00005"/></MenuItem>
          <MenuItem value={1}><FormattedMessage id = "langID00006"/></MenuItem>
          <MenuItem value={2}><FormattedMessage id = "langID00007"/></MenuItem>
          <MenuItem value={3}><FormattedMessage id = "langID00008"/></MenuItem>
          <MenuItem value={4}><FormattedMessage id = "langID00009"/></MenuItem>
        </Select>
      </FormControl >
            <InputLabel htmlFor="email-hero" sx={visuallyHidden} >
            
            </InputLabel>
            <TextField
              id="email-hero"
              hiddenLabel
              size="medium"
              variant="outlined"
              placeholder={intl.formatMessage({ id: "langID00016" })}
              autoComplete= 'off'
              InputProps={{ endAdornment: <AddButton /> }}
              sx={{ m: 1, minWidth: 700,height:60}}
              onChange={handleChangeInput}
              onKeyDown={e => {
                // e.keyCodeは常に0になる
                if(keyword !==""){
                if (e.key === 'Enter') {
                  // エンターキー押下時の処理
                  // document.getElementById("demo-form").submit();
                                        ReactGA.event({
      category: "Search Button",
      action: "Search Button",
      label: keyword, // Optional
    });
                  const aaa = document.getElementById("sc");
                  aaa?.click();
                }
              }
                
              }}
            />

            </Box>
            
            <Link hidden id="sc" to="/search" state={{keyword:keyword,category:category}}>テキスト</Link>
          </Stack>
<FormattedMessage id = "langID00042"/><br />
          <div style={{fontSize: "0.8em"}}>
          <FormattedMessage id = "langID00061"/>
          
          <Link to="https://www.alsi.co.jp/privacy/" target="_blank"><FormattedMessage id = "langID00062"/>&nbsp;</Link>
          <FormattedMessage id = "langID00063"/>
          <Link to="/Threat_Intelligence_Platform.pdf" target="_blank"><FormattedMessage id = "langID00064"/>&nbsp;</Link>
          <FormattedMessage id = "langID00065"/>
          </div>
        </Stack>
      </Container>
    <input type="hidden" name="recaptcha_response" id="recaptchaResponse"></input>
    
    </Box>
  );
}
